import Api from "./api.service";
import { decamelizeKeys } from "humps";

class Discounts {
  static getAll(tenantSlug) {
    return Api.get(`/api/v1/tenants/${tenantSlug}/discounts`, {
      params: {
        include: "discountable_product,discountable_customer,discount_fixed_amounts"
      }
    });
  }

  static get(id, tenantSlug) {
    return Api.get(`/api/v1/tenants/${tenantSlug}/discounts/${id}`, {
      params: {
        include: "discountable_product,discountable_customer,discount_fixed_amounts"
      }
    });
  }

  static create(tenantSlug, data) {
    const params = decamelizeKeys(data.discount);
    const {
      name,
      item,
      netsuite_description,
      amount,
      discount_type,
      discountable_product_type,
      discountable_customer_type,
      discountable_product_slug,
      discountable_customer_slug
    } = params;

    const payload = {
      data: {
        type: "discounts",
        attributes: { name, item, netsuite_description, amount, discount_type },
        relationships: {
          discountable_product: {
            data: {
              type: discountable_product_type === "Product" ? "products" : "product_groups",
              id: discountable_product_slug
            }
          },
          discountable_customer: {
            data: {
              type: discountable_customer_type === "Customer" ? "customers" : "customer_groups",
              id: discountable_customer_slug
            }
          }
        }
      }
    };

    return Api.post(`/api/v1/tenants/${tenantSlug}/discounts`, payload);
  }

  static update(id, tenantSlug, data) {
    const params = decamelizeKeys(data.discount);
    const {
      name,
      item,
      netsuite_description,
      amount,
      discount_type,
      discountable_product_type,
      discountable_customer_type,
      discountable_product_slug,
      discountable_customer_slug
    } = params;

    const payload = {
      data: {
        id: id,
        type: "discounts",
        attributes: { name, item, netsuite_description, amount, discount_type },
        relationships: {
          discountable_product: {
            data: {
              type: discountable_product_type === "Product" ? "products" : "product_groups",
              id: discountable_product_slug
            }
          },
          discountable_customer: {
            data: {
              type: discountable_customer_type === "Customer" ? "customers" : "customer_groups",
              id: discountable_customer_slug
            }
          }
        }
      }
    };

    return Api.put(`/api/v1/tenants/${tenantSlug}/discounts/${id}`, payload);
  }

  static createPrice(discountSlug, tenantSlug, discountPricesAttributes) {
    const { amount, currency } = discountPricesAttributes;
    const payload = {
      data: {
        type: "discount_fixed_amounts",
        attributes: {
          amount,
          currency
        },
        relationships: {
          discount: {
            data: {
              id: discountSlug,
              type: "discounts"
            }
          }
        }
      }
    };

    return Api.post(`/api/v1/tenants/${tenantSlug}/discounts/${discountSlug}/discount_fixed_amounts`, payload);
  }

  static updatePrice(discountSlug, slug, tenantSlug, discountPricesAttributes) {
    const { amount, currency } = discountPricesAttributes;

    const payload = {
      data: {
        type: "discount_fixed_amounts",
        id: slug,
        attributes: {
          amount,
          currency
        }
      }
    };

    return Api.put(`/api/v1/tenants/${tenantSlug}/discounts/${discountSlug}/discount_fixed_amounts/${slug}`, payload);
  }

  static deletePrice(discountSlug, slug, tenantSlug) {
    return Api.delete(`/api/v1/tenants/${tenantSlug}/discounts/${discountSlug}/discount_fixed_amounts/${slug}`);
  }
}

const DiscountsService = Object.freeze(Discounts);
export default DiscountsService;
